import type { RGBAObject } from "./types/RGBAObject.types";

export const RGBAObjectToString = (color: RGBAObject): string => {
  return `rgb(${color.r}, ${color.g}, ${color.b}, ${color.a ?? 1})`;
};
